import { Box, Typography, Button, Card, CardMedia } from '@mui/material';

export default function AffiliateCard({
  title,
  url,
  image,
  description,
  buttonText = "Learn More",
  highlight
}) {
  const isHighlighted = highlight === "true" || highlight === true;

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'stretch',
        mb: 3,
        border: '1px solid',
        borderColor: isHighlighted ? 'primary.main' : 'divider',
        borderRadius: 2,
        boxShadow: 0,
        bgcolor: 'background.paper',
        transition: 'box-shadow 0.2s ease, transform 0.2s ease',
        '&:hover': {
          boxShadow: 2,
          transform: 'translateY(-1px)',
        },
      }}
    >
      {/* Image */}
      {image && (
        <CardMedia
          component="img"
          image={image}
          alt={title}
          sx={{
            width: { xs: '100%', sm: 200 },
            height: { xs: 160, sm: 'auto' },
            objectFit: 'cover',
            borderTopLeftRadius: { sm: '8px', xs: '8px' },
            borderBottomLeftRadius: { sm: '8px', xs: 0 },
          }}
        />
      )}

      {/* Content */}
      <Box
        sx={{
          flex: 1,
          p: { xs: 2, sm: 2.5 },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: 1,
        }}
      >
        {title && (
          <Typography
            variant="subtitle1"
            component="h3"
            sx={{
              fontWeight: 600,
              color: 'text.primary',
            }}
          >
            {title}
          </Typography>
        )}

        {description && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ lineHeight: 1.6 }}
          >
            {description}
          </Typography>
        )}

        {url && (
          <Button
            variant="outlined"
            color={isHighlighted ? "primary" : "inherit"}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            sx={{
              alignSelf: 'flex-start',
              mt: 0.5,
              textTransform: 'none',
              borderRadius: 2,
              fontWeight: 500,
            }}
          >
            {buttonText}
          </Button>
        )}
      </Box>
    </Card>
  );
}
